<template>
  <el-container class="goods-trace-container">
     <div class="camera-scan-container" v-if="showCameraModal">
        <!-- 视频预览容器 -->
        <div class="video-container">
          <!-- 顶部提示文字 -->
          <div class="close-btn-wrapper" @click="closeCameraScan">
               <div class="close-btn-bg">
		      <div class="close-icon-text">返回</div>
		    </div>
          </div>
          <div class="camera-selector" v-if="availableCameras.length">
            <span class="camera-selector-label">摄像头</span>
            <button
              type="button"
              class="camera-select-trigger"
              :disabled="switchingCamera"
              @click.stop="cameraDropdownOpen = !cameraDropdownOpen"
            >
              <span>{{ selectedCameraLabel }}</span>
              <span class="camera-select-arrow">⌄</span>
            </button>
            <div class="camera-select-menu" v-if="cameraDropdownOpen">
              <div
                class="camera-select-option"
                :class="{ active: camera.deviceId === selectedCameraId }"
                v-for="(camera, index) in availableCameras"
                :key="camera.deviceId || index"
                @click.stop="selectCamera(camera)"
              >
                {{ camera.label || ('摄像头 ' + (index + 1)) }}
              </div>
            </div>
          </div>
          <div class="header-tips">
            <div class="header-tip">1: 将激活码对准蓝色框内。</div>
            <div class="header-tip">2: 调整正确距离,包装对焦清晰。</div>
            <div class="header-tip">3: 保持画面稳定,避免移动或震动。</div>
          </div>
      
         
          <video 
            ref="videoElement" 
            class="camera-preview" 
            autoplay 
            playsinline 
            muted
          ></video>
          <!-- 扫描框遮罩 -->
          <div class="scan-overlay">
            <div class="scan-frame"></div>
            <!-- <div class="scan-frame-inner"></div> -->
            <div class="scan-tips" v-if="scanningTip">
              {{ scanningTip }}
            </div>
          </div>
          
        </div>
         <canvas 
          ref="previewCanvas" 
          class="hidden-canvas"
        ></canvas>
        <!-- 隐藏的Canvas用于帧处理和识别 -->
        <canvas 
          ref="captureCanvas" 
          class="hidden-canvas"
          width="640" 
          height="480"
        ></canvas>
       

        <!-- 控制按钮 -->
       
      </div>
    <!-- 顶部Header：商品溯源 -->
    <el-header style="height: 50px;">
      <div class="header-content">
        <h1 class="title">商品溯源</h1>
      </div>
    </el-header>

    <!-- 中间主体内容 -->
    <el-main class="page-main">
      <!-- 加载状态提示（请求未完成时显示） -->
      <div class="loading-container" v-if="isLoading">
        <div class="loading-spinner" :style="{ width: size, height: size }"></div>
        <p class="loading-text">{{ text }}</p>
      </div>

      <!-- 错误状态提示（请求失败/参数缺失时显示） -->
      <div class="error-container" v-if="!isLoading && errorMsg">
        <p class="error-text">{{ errorMsg }}</p>
      </div>

      <!-- 商品核心信息（请求成功且数据有效时显示） -->
      <div class="content" v-if="!isLoading && !errorMsg && goodInfo&& skuinfo">
        <!-- 商品图片+基础信息 -->
        <div class="goods-trace-detail">
          <div class="goods-base-info">
            <img 
              :src="skuinfo.product.default_image_url" 
              alt="商品图片" 
              class="product-image"
            >
            <div class="goods-base-detail">
              <div class="goods-title">{{ skuinfo.title || '未知商品' }}</div>
              <div class="goods-barcode">条码：{{ activate_info.outer_sku_code || '无条码信息' }}</div>
              <div class="goods-barcode">SN码：{{ sn}}</div>
            </div>
          </div>
          <div class="detail-item">激活日期：{{ activate_info.activate_time ? activate_info.activate_time : '未激活' }}</div>
          <div class="detail-item">激活天数：{{ activate_info.activate_day ? activate_info.activate_day + '天' : '0天' }}</div>
          <div class="detail-item">质保天数：{{ activate_info.warranty_days || '0天' }}</div>
          <div class="detail-item">延保天数：{{ activate_info.extended_warranty_days || '0天' }}</div>
          <div class="detail-item">
            激活状态：
            <span :class="activate_info!=null && activate_info.status === 1  ? 'status-active' : 'status-inactive'">
              {{ activate_info && activate_info.status === 1 ? '已激活' : '未激活' }}
            </span>

            <div v-if="activate_info && activate_info.status !== 1" style="margin-top: 8px;color:#666; font-size: 14px;">
              先扫前码，再拍摄屏幕后码激活
            </div>
            <el-button 
              type="primary" 
              size="small"
              v-if="activate_info && activate_info.status !== 1 && s == 1"
              style=" position: absolute; right: 0;bottom: 0;  "
              @click="openCameraScan"
            >
              立即激活
            </el-button>
            <el-button 
              type="primary" 
              @click="handleToActivate" 
              size="small"
              v-if="activate_info && activate_info.status && activate_url"
              style=" position: absolute; right: 0;bottom: 0;  "
            >
              查看详细信息
            </el-button>
          </div>

          <div class="detail-item" style="display: flex;">激活图片：
            <el-image  v-if="activate_info.status"
              style="width: 80px; height: 80px"
              :src="activate_info.image" 
              :preview-src-list="[activate_info.image]">
            </el-image>
          </div>
        </div>
      </div>

      <!-- 商品溯源时间线 -->
      <div class="timeline" v-if="!isLoading && !errorMsg">
        <el-timeline>
          <el-timeline-item
            placement="top"
            v-for="(activity, index) in activities"
            :key="index"
            :color="activity.color || '#08cd7e'"
            :type="activity.type"
            :size="activity.size || 'large'"
            :timestamp="activity.timestamp || '未知时间'"
          >
            <el-card v-if="activity.action_type!='激活'">
              <div class="timeline-content">
                <div class="timeline-type"> 操作:{{ activity.action_type || '未知操作' }}</div>
                <div class="timeline-warehouse">仓库:{{ activity.warehouseLabel || '未知仓库' }}</div>
                <div class="timeline-contact">仓主:{{ activity.contact_name || '未知联系人' }}</div>
              </div>
            </el-card>
            <el-card v-else>
              <div class="timeline-content">
                <div class="timeline-type"> 操作:{{ activity.action_type || '未知操作' }}</div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-main>

    <!-- 底部按钮区域 -->
    <el-footer class="page-footer" :style="{ backgroundColor: (payStatus === 0 && !wx_url) || payStatus === 1 ? '#ccc' : '#409eff' }"  v-if="!isLoading && !errorMsg && goodInfo&& skuinfo">
      <div class="footer-content"  @click="handleBuy"  >
        <span v-if="payStatus === 0 && wx_url" style="color: #fff; font-size: 16px;" >
          立即购买
        </span>
        <span class="activated-tip" v-if="payStatus === 1">商品不在仓库</span>
        <span class="activated-tip" v-if="payStatus === 0 && !wx_url">商品不在共享仓中无法购买</span>
      </div>
    </el-footer>

    <!-- 摄像头扫描弹窗 -->
    <!-- <el-dialog
      title="商品激活扫码"
      v-model="showCameraModal"
      width="90%"
      top="10vh"
      :close-on-click-modal="false"
      :append-to-body="true"
    > -->
     
    <!-- </el-dialog> -->
    <!-- 二维码购买弹窗 -->
    <div class="qr-mobile-modal" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="qr-mobile-content">
        <div class="qr-mobile-header">
          <span class="qr-mobile-title">长按识别或扫码购买</span>
          <span class="qr-mobile-close" @click="showQrModal = false">×</span>
        </div>
        <div class="qr-mobile-body">
          <div class="qr-buy-code-wrapper">
            <img :src="qrCodeDataUrl" class="qr-buy-code" />
          </div>
          <p class="qr-buy-tip">长按识别或扫描二维码购买</p>
        </div>
        <div class="qr-mobile-footer">
          <el-button type="default" size="medium" round @click="showQrModal = false">关闭</el-button>
        </div>
      </div>
    </div>
  </el-container>
  
</template>

<script>
import wx from 'weixin-js-sdk';
import jsQR from 'jsqr';
export default {
  name: 'PayStatusRedirect',
  props: {
    size: {
      type: String,
      default: '40px',
      description: '转圈效果的尺寸（适配Element UI）'
    },
    color: {
      type: String,
      default: '#08cd7e',
      description: '主题色（按钮/加载动画/激活状态）'
    },
    showText: {
      type: Boolean,
      default: true,
      description: '是否显示提示文字'
    },
    text: {
      type: String,
      default: '加载中...',
      description: '默认加载文字'
    }
  },
  data() {
    return {
      isLoading: true,
      payStatus: null,
      errorMsg: '',
      sn: '',
      wx_url: "",
      activate_url: '',
      shop_id: '',
      other_id: '',
      goodInfo: null,
      skuinfo: null,
      activities: [],
      temfullUrl: '',
      activate_info: null,
      activationImageUrl: '',
      activationImageFile: null,
      uploadingActivation: false,
      s: '',

      // 摄像头扫码相关
      showCameraModal: false,
      isScanning: false,
      scanningTip: '',
      scanTimer: null,
      scanLock: false,
      lastScanTime: 0,
      detectedQRCode: null,
      mediaStream: null,
      cameraTrack: null,
      availableCameras: [],
      selectedCameraId: '',
      cameraDropdownOpen: false,
      switchingCamera: false,
      cameraCapabilities: null,
      cameraZoom: 1,
      cameraMaxZoom: 1,
      focusRetryTimer: null,
      captureInterval: null,
      // 接口识别相关
      recognitionCount: 0,
      maxRecognitionAttempts: 10,
      blurryFrameCount: 0,
      is_sale_to_activate:0,
      jump_mode: 0,
      showQrModal: false,
      qrCodeDataUrl: '',
    };
  },
  created() {
    this.$post(this.$api.get_wxsdk_config,{url:location.href.split('#')[0]}).then((res)=>{
       wx.config({
        // debug: true, // 开启调试模式,
        appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名，见附录1
        jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    })
    this.sn = this.$route.params.sn;
    this.shop_id = this.$route.params.shop_id;
    this.s = this.$route.query.s;
    this.fetchPayStatus();
  },
  beforeUnmount() {
    // 恢复页面滚动
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.bottom = '';
    
    // 页面卸载时释放摄像头资源
    this.stopScan();
    this.closeCameraScan();
  },
  computed: {
    selectedCameraLabel() {
      const camera = this.availableCameras.find(item => item.deviceId === this.selectedCameraId);
      return camera ? camera.label : '请选择摄像头';
    }
  },
  methods: {
    // 发起接口请求：查询商品的pay_status及完整信息
    async fetchPayStatus() {
      try {
        const res = await this.$get(`${this.$api.find_by_own_sn}?shop_id=${this.shop_id}&sn=${this.sn}`);
        
        this.isLoading = false;

        if (!res || !res.data) {
          this.errorMsg = '查找不到该商品，请检查参数';
          return;
        }

        const { pay_status, url, activate_url, good_info, good_history, sn, activate_info, warehouse_info, jump_mode } = res.data;
        this.payStatus = pay_status;
        this.wx_url = url;
        this.activate_url = activate_url;
        this.jump_mode = jump_mode || 0;
        this.goodInfo = good_info || null;
        this.is_sale_to_activate = warehouse_info && warehouse_info.warehouse && warehouse_info.warehouse.is_sale_to_activate ? warehouse_info.warehouse.is_sale_to_activate : 0;
        
        if (activate_info != null && activate_info.activate_status == 1) {
          this.activate_info = {
            outer_sku_code: activate_info.outer_sku_code || null,
            activate_time: activate_info.activate_time || null,
            trace_code: activate_info.trace_code || null,
            warranty_days: activate_info.warranty_days || null,
            image: activate_info.activate_img || null,
            status: activate_info.activate_status || 0,
            activate_day: (() => {
              const now = new Date();
              const activateTime = new Date(activate_info.activate_time);
              const diffMs = now - activateTime;
              const ONE_DAY = 1000 * 60 * 60 * 24;
              return diffMs >= 0 ? Math.floor(diffMs / ONE_DAY) || null : null;
            })()
          };
        } else {
          this.activate_info = {
            activate_time: null,
            warranty_days: null,
            trace_code: activate_info.trace_code || null,
            outer_sku_code: activate_info.outer_sku_code || null,
            status: 0,
            image: null,
            activate_day: 0,
          };
        }
       
        this.sn = sn;
        if (this.goodInfo && this.goodInfo.product) {
          this.skuinfo = this.goodInfo || null;
          if (this.skuinfo.image == null || this.skuinfo.image == "") {
            this.skuinfo.image = this.goodInfo.image || null;
          }
        }else{
          this.skuinfo = {
            product: {
              default_image_url: null,
            },
            title: null,
            outer_sku_code: null,
          };
        }
        
        if (activate_info != null && good_history != null && activate_info.activate_status == 1) {
          good_history.push({
            add_time: this.activate_info.activate_time,
            type: "activate",
          });
        }
        
        this.buildTimelineData(good_history || []);

        if (this.payStatus === 1 && url) {
          window.location = url;
        }

      } catch (err) {
        this.isLoading = false;
        this.errorMsg = '加载失败，请稍后重试';
        console.error('请求异常：', err);
      }
    },

    // 构建时间线数据
    buildTimelineData(historyList) {
   const sortedList = [...historyList].sort((a, b) => {
  const timeA = a.add_time ? new Date(a.add_time.replace(" ","T")).getTime() : 0;
  const timeB = b.add_time ? new Date(b.add_time.replace(" ","T")).getTime() : 0;
  return timeB - timeA;
});

      this.activities = sortedList.map(item => {
        if (item.type == "activate") {
          return {
            timestamp: item.add_time || '未知时间',
            action_type: '激活',
            color: '#ff4949',
          };
        } else {
          const warehouseLabel = item.warehouse && item.warehouse.label ? item.warehouse.label : '未知仓库';
          const invoiceData = item.inout2 || item.inout;
          const invoiceType = invoiceData ? invoiceData.invoice_type : null;
          const action_type = invoiceType === "in" ? "入库" : "出库";
          const color = invoiceType === "in" ? "#08cd7e" : "#409eff";
          const contact_name = item.warehouse.contact_name || '未知联系人';
          const address = item.warehouse.address || '未知地址';
          
          return {
            timestamp: item.add_time || '未知时间',
            warehouseLabel: warehouseLabel,
            action_type: action_type,
            color: color,
            contact_name: contact_name,
            address: address
          };
        }
      });

      if (this.activities.length === 0) {
        this.activities = [{
          timestamp: '无记录',
          content: '该商品暂无溯源记录',
          icon: 'el-icon-info',
          type: 'info'
        }];
      }
    },

    // 点击购买按钮
    handleBuy() {
      if (this.payStatus == 1 || !this.wx_url) {
        this.$message.error('商品不在共享仓中无法购买');
      } else if (this.jump_mode == 1) {
        try {
          const parsed = this.wx_url;
          console.log(parsed);
          
          if (parsed.code) {
            this.qrCodeDataUrl = 'data:image/png;base64,' + parsed.code;
          }
        } catch (e) {
          this.qrCodeDataUrl = this.wx_url;
        }
        this.showQrModal = true;
      } else if (this.wx_url) {
        window.location = this.wx_url;
      } else {
        this.errorMsg = '购买链接无效，请联系客服';
      }
    },
    saveQrCode() {
      if (!this.qrCodeDataUrl) return;
      const a = document.createElement('a');
      a.href = this.qrCodeDataUrl;
      a.download = 'qr_code.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.$message.success('已开始下载，请保存到相册');
    },

    // 打开摄像头扫描弹窗（修复核心）
    async openCameraScan() {
      if(this.payStatus == 0 &&this.is_sale_to_activate==1)
    {
       this.$message.error('请先购买后再激活');
       return;
    }
      try {
        console.log('[openCameraScan] 开始执行');
        
        // 禁止页面滚动
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '0';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.bottom = '0';
        
        // 1. 先显示弹窗
        this.showCameraModal = true;
        console.log('[openCameraScan] 弹窗已显示');
        
        // 2. 等待DOM完全渲染
        await this.$nextTick();
        console.log('[openCameraScan] DOM已渲染');
        
        // 3. 再次等待，确保Dialog完全打开
        await new Promise(resolve => setTimeout(resolve, 300));
        console.log('[openCameraScan] 等待300ms完成');

        // 4. 检查video元素是否存在
        const videoElement = this.$refs.videoElement;
        console.log('[openCameraScan] 第一次检查video元素:', videoElement);
        
        if (!videoElement) {
          // 再等一下，可能Dialog还没完全渲染
          await new Promise(resolve => setTimeout(resolve, 200));
          const videoElement2 = this.$refs.videoElement;
          console.log('[openCameraScan] 第二次检查video元素:', videoElement2);
          if (!videoElement2) {
            this.$message.error('视频容器初始化失败');
            this.showCameraModal = false;
            return;
          }
        }

        // 5. 请求摄像头权限：优先后置摄像头，并保留足够分辨率方便近距离识别
        console.log('[openCameraScan] 请求摄像头权限...');
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: 'environment' },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            frameRate: { ideal: 30, max: 30 }
          },
          audio: false
        });
        console.log('[openCameraScan] 摄像头权限获取成功:', stream);

        this.mediaStream = stream;
        this.cameraTrack = stream.getVideoTracks()[0] || null;
        await this.configureCameraTrack();
        const finalVideoElement = this.$refs.videoElement;
        console.log('[openCameraScan] 最终video元素:', finalVideoElement);
        
        if (!finalVideoElement) {
          this.$message.error('视频容器初始化失败');
          this.showCameraModal = false;
          return;
        }

        // 添加视频事件监听
        finalVideoElement.onloadedmetadata = () => {
          console.log('[openCameraScan] 视频元数据加载完成');
        };
        finalVideoElement.onplaying = () => {
          console.log('[openCameraScan] 视频开始播放');
        };
        finalVideoElement.onerror = (error) => {
          console.error('[openCameraScan] 视频加载错误:', error);
        };

        // 3. 修复视频流绑定：先清空旧流，再绑定新流
        finalVideoElement.srcObject = null;
        finalVideoElement.srcObject = stream;
        console.log('[openCameraScan] 视频流已绑定');

        // 4. 手动触发播放（解决移动端autoplay限制）
        console.log('[openCameraScan] 尝试播放视频...');
        finalVideoElement.play().then(() => {
          console.log('[openCameraScan] 视频播放成功');
          // this.scanningTip = '摄像头已就绪，请点击"开始识别"';
        }).catch(err => {
          console.error('[openCameraScan] 视频自动播放失败:', err);
          this.scanningTip = '请点击画面手动播放视频';
          // 兜底方案：给视频绑定点击播放事件
          finalVideoElement.addEventListener('click', () => {
            finalVideoElement.play().then(() => {
              console.log('[openCameraScan] 点击播放成功');
              // this.scanningTip = '摄像头已就绪，请点击"开始识别"';
            }).catch(err2 => {
              console.error('[openCameraScan] 点击播放也失败:', err2);
            });
          }, { once: true });
        });
        this.startScan()
      } catch (err) {
        console.error('[openCameraScan] 摄像头权限请求失败:', err);
        this.showCameraModal = false; // 权限失败时关闭弹窗
        if (err.name === 'NotAllowedError') {
          this.$message.error('请授予摄像头权限后重试');
        } else if (err.name === 'NotFoundError') {
          this.$message.error('未检测到摄像头设备');
        } else {
          this.$message.error('无法访问摄像头: ' + err.message);
        }
      }
    },

    async configureCameraTrack() {
      const track = this.cameraTrack;
      if (!track || typeof track.getCapabilities !== 'function' || typeof track.applyConstraints !== 'function') {
        return;
      }

      try {
        const capabilities = track.getCapabilities();
        this.cameraCapabilities = capabilities;
        const advanced = [];

        if (capabilities.focusMode && capabilities.focusMode.includes('continuous')) {
          advanced.push({ focusMode: 'continuous' });
        }

        if (capabilities.zoom) {
          const minZoom = capabilities.zoom.min || 1;
          const maxZoom = capabilities.zoom.max || minZoom;
          this.cameraMaxZoom = maxZoom;
          const targetZoom = Math.min(maxZoom, Math.max(minZoom, this.cameraZoom || 1.15));
          this.cameraZoom = targetZoom;
          advanced.push({ zoom: targetZoom });
        }

        if (advanced.length) {
          await track.applyConstraints({ advanced });
        }
      } catch (err) {
        console.warn('[configureCameraTrack] 当前设备不支持高级对焦参数:', err);
      }

      if (this.showCameraModal && this.cameraTrack) {
        clearTimeout(this.focusRetryTimer);
        this.focusRetryTimer = setTimeout(() => {
          this.configureCameraTrack();
        }, 1200);
      }
    },

    async adjustCameraZoom(step = 0.15) {
      const track = this.cameraTrack;
      const capabilities = this.cameraCapabilities;
      if (!track || !capabilities || !capabilities.zoom || typeof track.applyConstraints !== 'function') {
        return;
      }

      const minZoom = capabilities.zoom.min || 1;
      const maxZoom = Math.min(capabilities.zoom.max || minZoom, 2);
      const nextZoom = Math.min(maxZoom, Math.max(minZoom, (this.cameraZoom || minZoom) + step));

      if (nextZoom === this.cameraZoom) return;

      try {
        await track.applyConstraints({ advanced: [{ zoom: nextZoom }] });
        this.cameraZoom = nextZoom;
      } catch (err) {
        console.warn('[adjustCameraZoom] 当前设备不支持自动变焦:', err);
      }
    },

    getScanCrop(videoWidth, videoHeight) {
      const frameScale = 0.4;
      const cropSize = Math.floor(Math.min(videoWidth, videoHeight) * frameScale);
      const sx = Math.max(0, Math.floor((videoWidth - cropSize) / 2));
      const sy = Math.max(0, Math.floor((videoHeight - cropSize) / 2));

      return {
        sx,
        sy,
        sw: Math.min(cropSize, videoWidth - sx),
        sh: Math.min(cropSize, videoHeight - sy)
      };
    },

    isCanvasBlurry(canvas) {
      const ctx = canvas.getContext('2d');
      const sampleStep = 4;
      const sampleWidth = Math.floor(canvas.width / sampleStep);
      const sampleHeight = Math.floor(canvas.height / sampleStep);

      if (!ctx || sampleWidth < 8 || sampleHeight < 8) {
        return false;
      }

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      const gray = new Float32Array(sampleWidth * sampleHeight);

      for (let y = 0; y < sampleHeight; y++) {
        for (let x = 0; x < sampleWidth; x++) {
          const sourceIndex = ((y * sampleStep * canvas.width) + (x * sampleStep)) * 4;
          gray[y * sampleWidth + x] =
            imageData[sourceIndex] * 0.299 +
            imageData[sourceIndex + 1] * 0.587 +
            imageData[sourceIndex + 2] * 0.114;
        }
      }

      let sum = 0;
      let sumSquares = 0;
      let count = 0;

      for (let y = 1; y < sampleHeight - 1; y++) {
        for (let x = 1; x < sampleWidth - 1; x++) {
          const index = y * sampleWidth + x;
          const laplacian =
            gray[index - sampleWidth] +
            gray[index - 1] -
            gray[index] * 4 +
            gray[index + 1] +
            gray[index + sampleWidth];

          sum += laplacian;
          sumSquares += laplacian * laplacian;
          count++;
        }
      }

      const mean = sum / count;
      const variance = sumSquares / count - mean * mean;
      return variance < 45;
    },

    async buildEnhancedQrCanvas(sourceCanvas) {
      let crop = {
        sx: 0,
        sy: 0,
        sw: sourceCanvas.width,
        sh: sourceCanvas.height
      };

      if ('BarcodeDetector' in window) {
        try {
          const detector = new window.BarcodeDetector({ formats: ['qr_code'] });
          const codes = await detector.detect(sourceCanvas);
          const qrCode = codes && codes[0];

          if (qrCode && qrCode.boundingBox) {
            const padding = Math.round(Math.max(qrCode.boundingBox.width, qrCode.boundingBox.height) * 0.18);
            crop = {
              sx: Math.max(0, Math.floor(qrCode.boundingBox.x - padding)),
              sy: Math.max(0, Math.floor(qrCode.boundingBox.y - padding)),
              sw: Math.min(sourceCanvas.width, Math.ceil(qrCode.boundingBox.width + padding * 2)),
              sh: Math.min(sourceCanvas.height, Math.ceil(qrCode.boundingBox.height + padding * 2))
            };
          }
        } catch (err) {
          console.warn('[buildEnhancedQrCanvas] 浏览器暂不支持本地二维码定位:', err);
        }
      }

      const maxSide = Math.max(crop.sw, crop.sh);
      const targetSize = Math.min(1400, Math.max(900, maxSide * 2));
      const enhancedCanvas = document.createElement('canvas');
      enhancedCanvas.width = targetSize;
      enhancedCanvas.height = targetSize;

      const ctx = enhancedCanvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, targetSize, targetSize);
      ctx.imageSmoothingEnabled = false;
      ctx.filter = 'contrast(130%) brightness(105%)';

      const drawSize = Math.round(targetSize * 0.92);
      const offset = Math.round((targetSize - drawSize) / 2);
      ctx.drawImage(
        sourceCanvas,
        crop.sx,
        crop.sy,
        crop.sw,
        crop.sh,
        offset,
        offset,
        drawSize,
        drawSize
      );

      ctx.filter = 'none';
      return enhancedCanvas;
    },

    // 开始扫描识别（改为接口识别）
    startScan() {
      if (this.isScanning || this.scanLock) return;

      const videoElement = this.$refs.videoElement;
      // 检查视频是否正在播放
      if (videoElement && (videoElement.paused || videoElement.ended)) {
        this.scanningTip = '视频未播放，请先点击画面播放';
        videoElement.play().then(() => {
          this.startScan(); // 播放成功后重新触发扫描
        }).catch(() => {
          this.$message.error('无法播放视频，请检查设备权限');
        });
        return;
      }

      this.isScanning = true;
      this.scanningTip = '请将激活码放入框内，保持清晰后稍等';
      this.detectedQRCode = null;
      this.recognitionCount = 0; // 重置识别计数
      this.blurryFrameCount = 0;

      // 立即进行第一次识别
      if (!this.scanLock) {
        this.captureAndRecognizeFrame();
      }

      // 定时调用接口进行识别（2秒一次，必须等上一次识别完后才能进行下一次）
      this.captureInterval = setInterval(() => {
        if (!this.scanLock) {
          this.captureAndRecognizeFrame();
        }
      }, 800);
    },

    // 停止扫描
    stopScan() {
      this.isScanning = false;
      this.scanningTip = '已停止识别';
      this.recognitionCount = 0; // 重置识别计数
      this.blurryFrameCount = 0;
      
      if (this.captureInterval) {
        clearInterval(this.captureInterval);
        this.captureInterval = null;
      }

      if (this.focusRetryTimer) {
        clearTimeout(this.focusRetryTimer);
        this.focusRetryTimer = null;
      }
      
      if (this.scanTimer) {
        clearTimeout(this.scanTimer);
        this.scanTimer = null;
      }
      
      this.scanLock = false;
    },

    // 关闭摄像头扫描
    closeCameraScan() {
      this.showCameraModal = false;
      this.stopScan();
      
      // 恢复页面滚动
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.bottom = '';
      
      // 释放媒体流资源
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }
      this.cameraTrack = null;
      this.cameraCapabilities = null;
      this.cameraZoom = 1;
      this.cameraMaxZoom = 1;
      
      // 清空video元素
      const videoElement = this.$refs.videoElement;
      if (videoElement) {
        videoElement.srcObject = null;
      }
      
      this.detectedQRCode = null;
      this.scanningTip = '';
      this.cameraDropdownOpen = false;
      
      // 释放图片预览URL
      if (this.activationImageUrl) {
        URL.revokeObjectURL(this.activationImageUrl);
        this.activationImageUrl = '';
      }
      this.activationImageFile = null;
    },

    // 捕获视频帧并调用接口进行识别
    async captureAndRecognizeFrame() {
      if (!this.isScanning || this.scanLock || this.detectedQRCode) return;

      const now = Date.now();
      // 第一次识别（lastScanTime为0）跳过时间间隔检查
      if (this.lastScanTime > 0 && now - this.lastScanTime < 2000) return;

      this.scanLock = true;
      this.lastScanTime = now;

      try {
        const videoElement = this.$refs.videoElement;
        const captureCanvas = this.$refs.captureCanvas;
        
        if (!videoElement || !captureCanvas) {
          this.scanLock = false;
          return;
        }

        // 检查视频是否处于播放状态
        if (videoElement.paused || videoElement.ended) {
          this.scanningTip = '视频已暂停，请重新开始识别';
          this.scanLock = false;
          return;
        }

        const captureCtx = captureCanvas.getContext('2d');

        // 获取视频实际播放尺寸
        const videoWidth = videoElement.videoWidth || 1280;
        const videoHeight = videoElement.videoHeight || 720;

        const scanCrop = this.getScanCrop(videoWidth, videoHeight);

        // 只截取扫码框附近区域，减少背景干扰，也让二维码在上传图中占比更高
        captureCanvas.width = scanCrop.sw;
        captureCanvas.height = scanCrop.sh;
        captureCtx.drawImage(
          videoElement,
          scanCrop.sx,
          scanCrop.sy,
          scanCrop.sw,
          scanCrop.sh,
          0,
          0,
          scanCrop.sw,
          scanCrop.sh
        );

        if (this.isCanvasBlurry(captureCanvas)) {
          this.blurryFrameCount++;
          this.scanningTip = this.blurryFrameCount >= 2
            ? '画面有点模糊，请保持手机稳定，稍微拉远一点再对准'
            : '正在对焦，请保持手机稳定';
          await this.configureCameraTrack();
          if (this.blurryFrameCount >= 3) {
            await this.adjustCameraZoom(-0.1);
          }
          this.scanLock = false;
          return;
        }

        this.blurryFrameCount = 0;
        const recognitionCanvas = await this.buildEnhancedQrCanvas(captureCanvas);

        // 将canvas转换为Blob
        recognitionCanvas.toBlob(async (blob) => {
          if (!blob) {
            this.scanningTip = '图像捕获失败';
            this.scanLock = false;
            return;
          }

          // 捕获当前帧作为激活图片
          this.captureActivationImage(recognitionCanvas);
          
          // 显示识别中提示
          this.scanningTip = '识别中...';
          
          try {
            // 直接调用激活接口（包含识别功能）
            const result = await this.uploadActivationImage();
            this.scanLock = false;
            if (result.success) {
              // 激活成功
              this.scanningTip = '激活成功！';
              this.detectedQRCode = 'success';
              this.stopScan();
            } else {
              // 识别失败，根据错误类型显示不同提示
              this.recognitionCount++;
              
              if (result.errorType === 'qr_not_found') {
                this.scanningTip = `未识别到二维码，请保持二维码在框内清晰显示`;
                if (this.recognitionCount >= 2) {
                  await this.adjustCameraZoom(0.15);
                }
              } else if (result.errorType === 'wrong_qr_code') {
                this.scanningTip = `请识别正确的二维码`;
              } else if (result.errorType === 'image_not_found') {
                this.scanningTip = `图片获取中`;
              } else if (result.errorType === 'location_error') {
                this.scanningTip = `${result.msg}`;
              } else if (result.errorType === 'network_error') {
                this.scanningTip = `识别失败，请重试）`;
              } else {
                this.scanningTip = `${result.msg}`;
              }
              
              // 检查是否达到最大失败次数
              if (this.recognitionCount >= this.maxRecognitionAttempts) {
                this.scanningTip = '识别次数已用完，请退出后重新扫码识别';
                this.stopScan();
                setTimeout(() => {
                  this.closeCameraScan();
                }, 2000);
              }
            }
          } catch (err) {
            console.error('激活接口调用失败:', err);
            // 识别失败，增加失败计数
            this.recognitionCount++;
            this.scanningTip = `识别失败，请重试（${this.recognitionCount}/${this.maxRecognitionAttempts}）`;
            
            // 检查是否达到最大失败次数
            if (this.recognitionCount >= this.maxRecognitionAttempts) {
              this.scanningTip = '识别次数已用完，请退出后重新扫码识别';
              this.stopScan();
              setTimeout(() => {
                this.closeCameraScan();
              }, 2000);
            }
            this.scanLock = false;
          }
        }, 'image/png');

      } catch (err) {
        console.error('帧捕获失败:', err);
        // 识别失败，增加失败计数
        this.recognitionCount++;
        this.scanningTip = `未识别到激活码，请保持二维码在框内清晰显示（${this.recognitionCount}/${this.maxRecognitionAttempts}）`;
        
        // 检查是否达到最大失败次数
        if (this.recognitionCount >= this.maxRecognitionAttempts) {
          this.scanningTip = '识别次数已用完，请退出后重新扫码识别';
          this.stopScan();
          setTimeout(() => {
            this.closeCameraScan();
          }, 2000);
        }
        this.scanLock = false;
      }
    },

    // 捕获激活图片
    captureActivationImage(canvas) {
      try {
        // 将canvas转换为Blob，使用PNG格式（无损压缩）
        canvas.toBlob((blob) => {
          if (!blob) {
            this.scanLock = false;
            return;
          }

          // 创建File对象
          this.activationImageFile = new File([blob], `activation_${Date.now()}.png`, {
            type: 'image/png'
          });
          
          // 创建预览URL
          if (this.activationImageUrl) {
            URL.revokeObjectURL(this.activationImageUrl);
          }
          this.activationImageUrl = URL.createObjectURL(blob);
          
          // 不提示图片捕获成功，直接准备上传
        }, 'image/png');

      } catch (err) {
        console.error('捕获激活图片失败:', err);
        this.scanLock = false;
      }
    },

    // 上传激活图片并完成激活
    async openCameraScan() {
      if (this.payStatus == 0 && this.is_sale_to_activate == 1) {
        this.$message.error('请先购买后再激活');
        return;
      }

      try {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '0';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.bottom = '0';

        this.showCameraModal = true;
        this.scanningTip = '正在打开摄像头...';
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 200));

        const videoElement = this.$refs.videoElement;
        if (!videoElement) {
          this.$message.error('视频容器初始化失败');
          this.showCameraModal = false;
          return;
        }

        const stream = await this.startCameraStream(this.selectedCameraId);
        await this.refreshCameraList();

        this.cameraTrack = stream.getVideoTracks()[0] || null;
        const currentSettings = this.cameraTrack && this.cameraTrack.getSettings ? this.cameraTrack.getSettings() : {};
        this.selectedCameraId = currentSettings.deviceId || this.selectedCameraId;
        await this.configureCameraTrack();

        videoElement.srcObject = stream;
        try {
          await videoElement.play();
        } catch (err) {
          this.scanningTip = '请点击画面手动播放视频';
          videoElement.addEventListener('click', () => {
            videoElement.play().then(() => this.startScan());
          }, { once: true });
          return;
        }

        this.startScan();
      } catch (err) {
        console.error('[openCameraScan] 摄像头打开失败:', err);
        this.closeCameraScan();
        if (err.name === 'NotAllowedError') {
          this.$message.error('请授予摄像头权限后重试');
        } else if (err.name === 'NotFoundError') {
          this.$message.error('未检测到摄像头设备');
        } else {
          this.$message.error('无法访问摄像头: ' + err.message);
        }
      }
    },

    async startCameraStream(deviceId = '') {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('当前浏览器不支持摄像头');
      }

      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }

      const video = deviceId
        ? {
            deviceId: { exact: deviceId },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            frameRate: { ideal: 30, max: 30 }
          }
        : {
            facingMode: { ideal: 'environment' },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            frameRate: { ideal: 30, max: 30 }
          };

      const stream = await navigator.mediaDevices.getUserMedia({ video, audio: false });
      this.mediaStream = stream;
      return stream;
    },

    async refreshCameraList() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return;

      const devices = await navigator.mediaDevices.enumerateDevices();
      const cameras = devices
        .filter(device => device.kind === 'videoinput')
        .map((device, index) => ({
          deviceId: device.deviceId,
          label: device.label || `摄像头 ${index + 1}`
        }));

      const isBackCamera = camera => /back|rear|environment|后置|广角|wide/i.test(camera.label || '');
      this.availableCameras = cameras.sort((a, b) => Number(isBackCamera(b)) - Number(isBackCamera(a)));

      if (!this.selectedCameraId && this.availableCameras.length) {
        const backCamera = this.availableCameras.find(isBackCamera);
        this.selectedCameraId = (backCamera || this.availableCameras[0]).deviceId;
      }
    },

    async onCameraChange() {
      if (!this.showCameraModal || !this.selectedCameraId || this.switchingCamera) return;

      try {
        this.switchingCamera = true;
        this.stopScan();
        this.scanningTip = '正在切换摄像头...';
        const stream = await this.startCameraStream(this.selectedCameraId);
        this.cameraTrack = stream.getVideoTracks()[0] || null;
        this.cameraZoom = 1;
        await this.configureCameraTrack();

        const videoElement = this.$refs.videoElement;
        if (videoElement) {
          videoElement.srcObject = stream;
          await videoElement.play();
        }

        this.detectedQRCode = null;
        this.startScan();
      } catch (err) {
        console.error('[onCameraChange] 摄像头切换失败:', err);
        this.$message.error('摄像头切换失败，请换一个镜头试试');
      } finally {
        this.switchingCamera = false;
      }
    },

    async selectCamera(camera) {
      if (!camera || camera.deviceId === this.selectedCameraId) {
        this.cameraDropdownOpen = false;
        return;
      }

      this.cameraDropdownOpen = false;
      this.selectedCameraId = camera.deviceId;
      await this.onCameraChange();
    },

    // 前端先用 jsQR 识别二维码，识别通过后再交给后端校验激活
    startScan() {
      if (this.isScanning || this.scanLock) return;

      const videoElement = this.$refs.videoElement;
      if (videoElement && (videoElement.paused || videoElement.ended)) {
        this.scanningTip = '视频未播放，请先点击画面播放';
        videoElement.play().then(() => {
          this.startScan();
        }).catch(() => {
          this.$message.error('无法播放视频，请检查设备权限');
        });
        return;
      }

      this.isScanning = true;
      this.scanLock = false;
      this.detectedQRCode = null;
      this.recognitionCount = 0;
      this.blurryFrameCount = 0;
      this.lastScanTime = 0;
      this.scanningTip = '请将扫描框对准二维码，调整距离，识别成功后自动拍照';

      this.captureAndRecognizeFrame();
      this.captureInterval = setInterval(() => {
        this.captureAndRecognizeFrame();
      }, 160);
    },

    stopScan() {
      this.isScanning = false;
      this.recognitionCount = 0;
      this.blurryFrameCount = 0;

      if (this.captureInterval) {
        clearInterval(this.captureInterval);
        this.captureInterval = null;
      }

      if (this.focusRetryTimer) {
        clearTimeout(this.focusRetryTimer);
        this.focusRetryTimer = null;
      }

      if (this.scanTimer) {
        clearTimeout(this.scanTimer);
        this.scanTimer = null;
      }

      this.scanLock = false;
    },

    scanQrFromCanvas(sourceCanvas) {
      const tryDecode = (canvas) => {
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return null;

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        return jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'attemptBoth'
        });
      };

      const directQr = tryDecode(sourceCanvas);
      if (directQr && directQr.data) return directQr;

      const enhancedCanvas = document.createElement('canvas');
      enhancedCanvas.width = sourceCanvas.width;
      enhancedCanvas.height = sourceCanvas.height;
      const enhancedCtx = enhancedCanvas.getContext('2d', { willReadFrequently: true });
      enhancedCtx.imageSmoothingEnabled = false;

      const filters = [
        'contrast(145%) brightness(110%) saturate(120%)',
        'grayscale(100%) contrast(180%) brightness(115%)'
      ];

      for (const filter of filters) {
        enhancedCtx.clearRect(0, 0, enhancedCanvas.width, enhancedCanvas.height);
        enhancedCtx.filter = filter;
        enhancedCtx.drawImage(sourceCanvas, 0, 0);
        enhancedCtx.filter = 'none';

        const qr = tryDecode(enhancedCanvas);
        if (qr && qr.data) return qr;
      }

      return null;
    },

    async captureAndRecognizeFrame() {
      if (!this.isScanning || this.scanLock || this.detectedQRCode) return;

      const now = Date.now();
      if (this.lastScanTime > 0 && now - this.lastScanTime < 120) return;
      this.lastScanTime = now;

      try {
        const videoElement = this.$refs.videoElement;
        const captureCanvas = this.$refs.captureCanvas;
        if (!videoElement || !captureCanvas || !videoElement.videoWidth || !videoElement.videoHeight) {
          return;
        }

        if (videoElement.paused || videoElement.ended) {
          this.scanningTip = '视频已暂停，请点击画面重新播放';
          return;
        }

        const scanCrop = this.getScanCrop(videoElement.videoWidth, videoElement.videoHeight);
        const sampleSize = Math.max(480, Math.min(1280, scanCrop.sw));
        captureCanvas.width = sampleSize;
        captureCanvas.height = sampleSize;

        const captureCtx = captureCanvas.getContext('2d', { willReadFrequently: true });
        captureCtx.clearRect(0, 0, sampleSize, sampleSize);
        captureCtx.drawImage(
          videoElement,
          scanCrop.sx,
          scanCrop.sy,
          scanCrop.sw,
          scanCrop.sh,
          0,
          0,
          sampleSize,
          sampleSize
        );

        const qr = this.scanQrFromCanvas(captureCanvas);

        if (!qr || !qr.data) {
          this.scanningTip = '未识别到二维码，请让二维码完整进入框内并保持清晰';
          return;
        }

        const qrBox = this.getJsQrBox(qr);
        const qrRatio = qrBox ? qrBox.size / sampleSize : 0;
        if (qrRatio < 0.04) {
          this.scanningTip = '二维码太小，请靠近一点';
          return;
        }
        if (qrRatio > 0.9) {
          this.scanningTip = '二维码太近，请拉远一点';
          return;
        }

        const expectedCode = this.activate_info && this.activate_info.trace_code ? String(this.activate_info.trace_code) : '';
        if (expectedCode && String(qr.data).indexOf(expectedCode) === -1) {
          this.scanningTip = '请扫描当前商品对应的激活二维码';
          return;
        }

        this.scanLock = true;
        this.detectedQRCode = qr.data;
        this.scanningTip = '已识别二维码，正在拍照激活...';
        this.stopScan();

        const photoCanvas = await this.buildActivationPhotoCanvas(videoElement);
        await this.captureActivationImage(photoCanvas);
        const result = await this.uploadActivationImage();

        if (result.success) {
          this.scanningTip = '激活成功！';
          return;
        }

        this.detectedQRCode = null;
        this.scanLock = false;
        this.recognitionCount++;
        this.scanningTip = result.msg || '后端校验失败，请重新对准二维码';

        if (this.recognitionCount >= this.maxRecognitionAttempts) {
          this.scanningTip = '识别次数已用完，请退出后重新扫码';
          setTimeout(() => {
            this.closeCameraScan();
          }, 2000);
          return;
        }

        this.startScan();
      } catch (err) {
        console.error('jsQR识别或激活失败:', err);
        this.detectedQRCode = null;
        this.scanLock = false;
        this.recognitionCount++;
        this.scanningTip = '识别失败，请保持二维码在框内清晰显示';
      }
    },

    getJsQrBox(qr) {
      const location = qr && qr.location;
      if (!location) return null;
      const points = [
        location.topLeftCorner,
        location.topRightCorner,
        location.bottomRightCorner,
        location.bottomLeftCorner
      ];
      const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
      const xs = points.map(point => point.x);
      const ys = points.map(point => point.y);

      return {
        size: Math.max(
          distance(points[0], points[1]),
          distance(points[1], points[2]),
          distance(points[2], points[3]),
          distance(points[3], points[0])
        ),
        x: Math.min(...xs),
        y: Math.min(...ys),
        width: Math.max(...xs) - Math.min(...xs),
        height: Math.max(...ys) - Math.min(...ys)
      };
    },

    async buildActivationPhotoCanvas(videoElement) {
      const maxWidth = 1440;
      const sourceWidth = videoElement.videoWidth || 1280;
      const sourceHeight = videoElement.videoHeight || 720;
      const scale = sourceWidth > maxWidth ? maxWidth / sourceWidth : 1;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(sourceWidth * scale);
      canvas.height = Math.round(sourceHeight * scale);

      const ctx = canvas.getContext('2d');
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#ffff00';
      ctx.font = '16px sans-serif';
      const now = new Date();
      const pad = value => String(value).padStart(2, '0');
      const timeText = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      ctx.fillText(timeText, 10, 22);
      ctx.fillText(this.sn || '', 10, 44);

      return canvas;
    },

    captureActivationImage(canvas) {
      return new Promise((resolve, reject) => {
        try {
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('激活图片生成失败'));
              return;
            }

            this.activationImageFile = new File([blob], `activation_${Date.now()}.jpg`, {
              type: 'image/jpeg'
            });

            if (this.activationImageUrl) {
              URL.revokeObjectURL(this.activationImageUrl);
            }
            this.activationImageUrl = URL.createObjectURL(blob);
            resolve(this.activationImageFile);
          }, 'image/jpeg', 0.8);
        } catch (err) {
          reject(err);
        }
      });
    },

    async uploadActivationImage() {
      if (!this.activationImageFile) {
        this.scanLock = false;
        return { success: false, errorType: 'image_not_found', msg: '激活图片不存在' };
      }

      this.uploadingActivation = true;
      
      try {
        // 每次都获取最新的位置信息
        let latitude = '';
        let longitude = '';
        
        try {
          // 等待用户授权，获取最新定位
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            }
          });
        } catch (error) {
          console.error('获取定位失败:', error);
          this.uploadingActivation = false;
          this.scanLock = false;
          return { success: false, errorType: 'location_error', msg: '定位授权失败，请允许定位权限后重试' };
        }

        // 判断图片大小，如果大于1MB则进行压缩
        const maxSize = 1036000; // 最大1036000字节
        let fileToUpload = this.activationImageFile;
        
        if (fileToUpload.size > maxSize) {
          console.log('原始图片大小:', (fileToUpload.size / 1024).toFixed(2), 'KB');
          
          // 尝试压缩，从高质量开始逐步降低
          let quality = 0.9;
          while (quality > 0.1) {
            fileToUpload = await this.compressToJpgKB(this.activationImageFile, quality);
            console.log('压缩后图片大小:', (fileToUpload.size / 1024).toFixed(2), 'KB, 质量:', quality);
            
            if (fileToUpload.size <= maxSize) {
              break;
            }
            quality -= 0.1;
          }
        }

        // 构建表单数据
        const formData = new FormData();
        // formData.append('sn', this.sn);
        formData.append('image', fileToUpload);
        formData.append('product_code', this.activate_info.trace_code || '');
        formData.append('qr_code', this.detectedQRCode || '');
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);

        // 上传激活
        const response = await fetch(this.$api.activate_product, {
          method: 'POST',
          body: formData
        });

        const res = await response.json();
        this.uploadingActivation = false;

        if (res && res.status == 200) {
          this.$message.success('激活成功！');
          this.closeCameraScan();
          this.fetchPayStatus(); // 重新加载数据
          return { success: true };
        } else {
          // 根据不同的错误信息返回不同的错误类型
          let errorType = 'unknown';
          if (res.msg === '二维码识别失败') {
            errorType = 'qr_not_found';
          } else if (res.msg === '请拍正确的激活码') {
            errorType = 'wrong_qr_code';
          }
          
          return { success: false, errorType: errorType, msg: res.msg || '激活失败' };
        }

      } catch (e) {
        this.uploadingActivation = false;
        console.error('激活异常:', e);
        return { success: false, errorType: 'network_error', msg: '激活失败，请检查网络' };
      }
    },

    // 压缩图片（保留原有方法）
    async compressToJpgKB(file, quality = 0.6) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        const fileUrl = URL.createObjectURL(file);
        img.src = fileUrl;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error('JPG格式压缩失败'));
                return;
              }
              const compressedFile = new File(
                [blob],
                file.name.replace(/\.\w+$/, '.jpg'),
                { type: 'image/jpeg' }
              );
              URL.revokeObjectURL(fileUrl);
              resolve(compressedFile);
            },
            'image/jpeg',
            quality
          );
        };

        img.onerror = (err) => {
          URL.revokeObjectURL(fileUrl);
          reject(err);
        };
      });
    },

    // 查看详细信息（原有方法）
    handleToActivate() {
      if (this.activate_url) {
        window.open(this.activate_url, '_blank');
      } else {
        this.$message.warning('暂无详细信息');
      }
    }
  }
};
</script>

<style scoped>
/* 全局容器样式 */
.goods-trace-container {
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", sans-serif;
}

/* 顶部Header样式 */
/deep/.page-header {
  padding: 0;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.header-content {
  text-align: center;
  height: 50px;
  line-height: 50px;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 中间主体样式 */
/deep/.page-main {
  padding: 10px;
  background-color: #f8f9fa;
  overflow-y: auto;
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: v-bind(color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #666;
}

/* 错误状态样式 */
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.error-text {
  font-size: 16px;
  color: #ff4444;
  text-align: center;
  padding: 0 20px;
}

/* 商品内容样式 */
.content {
  margin-bottom: 20px;
}

/* 商品基础信息（图片+名称+条码） */
.goods-base-info {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}

.product-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.goods-base-detail {
  margin-left: 20px;
}

.goods-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.goods-barcode {
  font-size: 16px;
  color: #666;
}

/* 商品溯源详情 */
.goods-trace-detail {
  background-color: #fff;
  padding: 20px;
}

.detail-item {
  position: relative;
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* 激活状态样式 */
.status-active {
  color: #08cd7e !important;
  font-weight: 500;
}

.status-inactive {
  color: #ff9500 !important;
  font-weight: 500;
}

/* 时间线样式 */
.timeline {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.timeline-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 底部Footer样式 */
.page-footer {
  padding: 20px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 已激活提示样式 */
.activated-tip {
  font-size: 16px;
  color: #666;
  line-height: 50px;
  display: block;
  text-align: center;
}

/deep/.el-timeline{
  padding: 0;
}

/deep/.el-card__body{
  padding: 10px;
}

/* 摄像头扫描样式（优化视频显示） */
.camera-scan-container {
    position: absolute;
  width: 100vw;
  height: 100vh; /* 固定高度 */
}

.video-container {
 width: 100%;
 height: 100%;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  z-index: 1;
  display: block;
}

.header-tips {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  z-index: 3;
  padding: 0 20px;
}

.header-tip {
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
}

.camera-selector {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(100vw - 24px);
  max-width: 340px;
  padding: 7px 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  font-size: 13px;
}

.camera-selector-label {
  flex: 0 0 auto;
  white-space: nowrap;
}

.camera-select-trigger {
  flex: 1;
  min-width: 0;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 8px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 8px;
  background: #222;
  color: #fff;
  font-size: 13px;
  outline: none;
}

.camera-select-trigger span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.camera-select-arrow {
  flex: 0 0 auto;
  font-size: 16px;
  line-height: 1;
}

.camera-select-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  max-height: 190px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  background: rgba(20, 20, 20, 0.96);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
}

.camera-select-option {
  padding: 10px 12px;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.camera-select-option + .camera-select-option {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.camera-select-option.active {
  background: rgba(64, 158, 255, 0.45);
}

.scan-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}

.scan-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  /* height: 33.33%; */
  aspect-ratio: 1/1;
  max-width: 240px;
  max-height: 240px;
  border: 2px solid #409eff;
  border-radius: 8px;
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 1);
}

.scan-frame-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13.33%;
  height: 13.33%;
  aspect-ratio: 1/1;
  max-width: 53.33px;
  max-height: 53.33px;
  border: 2px solid #ff4444;
  border-radius: 4px;
}
.close-btn-wrapper {
  position: absolute;
  top: 25px;
  right: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn-bg {
  min-width: 50px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.7);
  border: 1px solid #ffffff;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;

}

.close-icon-text {
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  line-height: 1;
  display: block;
  white-space: nowrap;
}
.scan-tips {
  position: absolute;
  top: calc(50% + 204px); /* 位于框下面20px */
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 0;
  z-index: 3;
}

.hidden-canvas {
  /* display: none; */
}

.camera-controls {
  margin-top: 15px;
  z-index: 10;
}

/* 二维码购买弹窗样式 */
.qr-mobile-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  -webkit-overflow-scrolling: touch;
}

.qr-mobile-content {
  width: 90%;
  max-width: 380px;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.qr-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.qr-mobile-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.qr-mobile-close {
  font-size: 24px;
  color: #999;
  line-height: 1;
  cursor: pointer;
  padding: 4px;
}

.qr-mobile-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 24px 0 24px;
}

.qr-buy-code-wrapper {
  width: 100%;
  max-width: 320px;
  aspect-ratio: 1;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.qr-buy-code {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: contain;
}

.qr-buy-tip {
  margin-top: 16px;
  font-size: 13px;
  color: #999;
}

.qr-mobile-footer {
  display: flex;
  gap: 12px;
  padding: 12px 20px 20px;
}

.qr-mobile-footer .el-button {
  flex: 1;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/skip/index3.vue